import React from 'react'

function Returnrefund() {
    return (<div className="container " style={{ fontSize: '18px', textAlign: 'justify' }}>
        <h2 className='mt-3'><strong>Return and refund policy</strong></h2>

        <p>We have no return policy, which means you can’t request a return because this is not physical products.</p>
        <p>You can always contact us for any question at support@kodenuats.com</p>
        <h3><strong>Refunds</strong></h3>
        <p>We will notify you once we’ve received and inspected your refund request, and let you know if the refund was approved or not. If approved, you’ll be automatically refunded on your original payment method within 15 business days. Please remember it can take some time for your bank or credit card company to process and post the refund too.</p>

        <p> If more than 20 business days have passed since we’ve approved your return, please contact us at support@kodenuats.com</p>

    </div>
    )
}

export default Returnrefund